
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.75 1.45L1.5 17.206H24L12.75 1.451z","stroke":"#8F7A61","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.78 12.947c.218 0 .395.065.529.194.134.13.201.295.201.497a.654.654 0 01-.201.491.73.73 0 01-.53.195.726.726 0 01-.526-.195.653.653 0 01-.2-.491c0-.2.066-.364.2-.495a.722.722 0 01.526-.196zm.54-.713h-1.082l-.153-4.552h1.39l-.155 4.552z","fill":"#8F7A61"}})])
          )
        }
      }
    